import { render, staticRenderFns } from "./background-image-attachment.vue?vue&type=template&id=cb82ae42&"
import script from "./background-image-attachment.vue?vue&type=script&lang=js&"
export * from "./background-image-attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports